import React from 'react';
import Layout from "../../components/Layout";
import {wrapper} from "../../store";
import {getAllBlogPosts, getBlogPost, getRunningQueriesThunk, useGetBlogPostQuery} from "../../rtk-api/blog";
import Link from "next/link";
import {handleStatusCode} from "../../helpers/utils";
import {NextSeo} from "next-seo";
import Breadcrumbs from "../../components/inc/breadcrumbs";

export const getServerSideProps = wrapper.getServerSideProps(store => async ({req, params}) => {
	const {id} = params

	let errorStatus;
	store.dispatch(getBlogPost.initiate(id)).then((data) => errorStatus = data.error?.status);
	await Promise.all(store.dispatch(getRunningQueriesThunk()));
	if (errorStatus !== undefined) {
		return handleStatusCode(errorStatus)
	}
	
	return {
		props: {id},
	};
});


function Index(props) {
	
	const {data:post} = useGetBlogPostQuery(props.id)
	
	function url() {
		return process.env.NEXT_PUBLIC_BLOG_URL + '/' + post?.data.slug
	}
	
	function sharableUrl() {
		return encodeURIComponent(url())
	}
	
	
	function createMarkup() {
		return {__html: post?.data.body};
	}
	
	return (
		<Layout>
			<NextSeo
				title={`${post?.data.title} - PageName Blog`}
				description={`${post?.data.preview_text}`}
				openGraph={{
					type: 'website',
					url: process.env.NEXT_PUBLIC_BLOG_URL + '/' + props.id,
					title: `${post?.data.title} - PageName Blog`,
					description: `${post?.data.preview_text}`,
					images: [
						{
							url: post?.data.image,
							width: 1200,
							height: 641,
							alt: `${post?.data.preview_text}`,
							// type: 'image/jpg',
						}
					],
					siteName: 'PageName',
				}}
				twitter={{
					site: '@pagenamer',
					cardType: 'summary_large_image',
				}}
			/>
			<section className="px-5">
				<div className="container">
				
				<Breadcrumbs
					href={`/category/${post?.data.categories[0].name}`}
					text={post?.data.categories[0].name}
					additional={'Post'}
				/>
				
				<div>
					
					<header className="col-12 p-0 text-center">
						<h1 className="heading text-4xl font-bold mb-6">{post?.data.title}</h1>
						<div>
							<div className="text-center">
								<div className="inline-block mr-2">
									<span className="radius text-decoration-none">
										by <b>{post?.data.author_name}</b>
									</span>
									<span>&nbsp;·&nbsp;</span>
									<span className="">{post?.data.est_reading_time}</span>
									<span className="fa">&nbsp;·&nbsp;</span>
									<Link href={'/category/' + post?.data.categories[0].name} className="text-decoration-none">{post?.data.categories[0].name}</Link>
									<span>&nbsp;·&nbsp;</span>
									<span suppressHydrationWarning>{new Date(post?.data.created_at).toLocaleDateString('en-us', {  year:"numeric", month:"long", day:"numeric"}) }</span>
									<span>&nbsp;·&nbsp;</span>
									<ul className="d-inline m-0 p-0" style={{fontSize:'.75rem'}}>
										{post?.data.tags.map((tag) =>
											<Link
												className="badge badge-info text-decoration-none p-1 d-inline-block"
												href={'/tags/' + tag.slug.en}
												style={{color:'white',outline: 'none',boxShadow: 'none',borderRadius: '9999px'}}
											>{tag.slug.en}</Link>
										)}
									</ul>
								</div>
							</div>
						</div>
						
						
						<div className="d-block mt-6">
							<div className="text-center p-0 mb-5">
								<span className="">Share: </span>
								<a className="text-decoration-none font-bold" style={{color:'#3b5998'}}
								   href={'https://www.facebook.com/sharer/sharer.php?u=' + sharableUrl() }
								   target="_blank">Facebook</a>
								&nbsp;·&nbsp;
								<a className="text-decoration-none font-bold" style={{color:'#08a0e9'}}
								   href={'https://twitter.com/intent/tweet?text='+post?.data.preview_text.replace(' ', '+') + ' ' + sharableUrl() }
								   data-size="large" target="_blank">Twitter</a>
								&nbsp;·&nbsp;
								<a className="text-decoration-none font-bold" style={{color:'#0077B5'}}
								   href={'https://www.linkedin.com/sharing/share-offsite/?url=' + sharableUrl() }
								   target="_blank">LinkedIn</a>
								&nbsp;·&nbsp;
								<a className="text-decoration-none font-bold copy-link" href={url()}
								   target="_blank">Copy Link</a>
							</div>
						</div>
					</header>
					
					<div>
						<figure className="image-larger main-blog-img mb-5" style={{
                        paddingTop: '56.25%',
                        backgroundImage: `url('${post?.data.image}')`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'}}></figure>
					</div>
					<div className="container-sm pb-5 post-body text-lg">
						<div className="leading-loose" dangerouslySetInnerHTML={createMarkup()} />
						<hr className="mb-5" />
						<div className="container-sm d-inline-flex ">
							{post?.data.user.image &&
								<div className="d-inline col-2">
									<img className="rounded-circle mr-2" src={post?.data.user.image} width="125" height="125" alt={post?.data.user.name} />
								</div>
							}
							<div className="d-inline col-10">
								<div className="font-bold mb-2">By {post?.data.author_name}</div>
								<div style={{fontSize:'.8em'}}>
									{post?.data.user.bio}
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<section className="bg-blue-500 text-white p-10 text-center mb-5">
					<div className="container">
						<div className="cta-inner section-inner reveal-scale-down is-revealed">
							<div className="cta-slogan mb-4">
								<div className="container-xs">
									<h2 className="heading text-3xl !text-white mb-5">Like what you see?</h2>
									<p className="text-xl">Get started with our free plan today!</p>
								</div>
							</div>
							<a className="block btn-primary !bg-[#02C6F1] !hover:bg-[#05d0fd] uppercase py-4" href={process.env.NEXT_PUBLIC_ORIGINAL_URL + '/pricing'}>Get started</a>
						</div>
					</div>
				</section>
			</div>
			</section>
		</Layout>
	);
}

export default Index;
